module.exports = __webpack_public_path__ + "static/media/solar-panel-sun-thin.c7be357f.svg";